import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  base: __dirname,
  mode: 'history',
  
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  routes: [
    { 
      path: "/",
      component: () => import('../modules/principal/PrincipalView.vue'),
      children: [
        {
          path: "/",
          component: () => import('../modules/inicio/InicioView.vue'),
        },
        {
          path: "/imoveis/:operacao",
          name: "imoveis",
          component: () => import('../modules/lista/ListaView.vue'),
        },
        {
          path: "/imoveis/:operacao/:param1",
          component: () => import('../modules/lista/ListaView.vue'),
        },
        {
          path: "/imoveis/:operacao/:param1/:param2",
          component: () => import('../modules/lista/ListaView.vue'),
        },
        {
          path: "/imoveis/:operacao/:param1/:param2/:param3",
          component: () => import('../modules/lista/ListaView.vue'),
        },
        {
          path: "/imovel/:id",
          name: "imovel",
          component: () => import('../modules/imovel/ImovelView.vue'),
        },
        {
          path: "/imovel/:id/:urlAmigavel",
          name: "imovel",
          component: () => import('../modules/imovel/ImovelView.vue'),
        },
        {
          path: "/quemSomos",
          name: "quemSomos",
          component: () => import('../modules/quemsomos/QuemSomosView.vue'),
        },
        {
          path: "/faleConosco",
          name: "faleConosco",
          component: () => import('../modules/faleconosco/FaleConoscoView.vue'),
        },
        {
          path: "/anuncieImovel",
          name: "anuncieImovel",
          component: () => import('../modules/anuncie/AnuncieImovelView.vue'),
        },   
        {
          path: "/404",
          name: "notFound",
          component: () => import('../modules/notfound/NotFoundView.vue'),
        },
      ]
    },

    {
      path: '*',
      redirect: '/',
    },
  ]
})

export default router;